import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ShareImageToSocialMedia from "core/ShareImageToSocialMedia";
import FacebookIcon from "core/jsSvgIcons/Facebook";

let ShareImageToFacebook = ({
    className,
    creatorName,
    imageType,
    permalinkPath,
    height,
    width,
    color
}) => (
    <ShareImageToSocialMedia
        className={className}
        creatorName={creatorName}
        platform="Facebook"
        imageType={imageType}
        permalinkPath={permalinkPath}
    >
        <FacebookIcon
            title="Facebook logo"
            size={width && height && { width, height }}
            fillColor={color}
        />
    </ShareImageToSocialMedia>
);

ShareImageToFacebook.propTypes = {
    className: PropTypes.string,
    creatorName: PropTypes.string.isRequired,
    imageType: PropTypes.oneOf(["photo", "icon"]).isRequired,
    permalinkPath: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    color: PropTypes.string
};

ShareImageToFacebook = styled(ShareImageToFacebook)``;

export default ShareImageToFacebook;
